export const setUrl = (url, base = '') => {
  const NODE_ENV = process.env.NODE_ENV
  switch (base) {
    case 'sso': 
      return '/api/sso' + url
    default:
      return '/api/authcenter' + url
  }
}



// WEBPACK FOOTER //
// ./src/utils/url.js